import {IManufacturer, IManufacturerAPI, IManufacturerQuery} from 'interfaces';
import {axiosAPI} from './API';

interface IManufacturerCreateResponse {
    id: number,
}

// device crud operations, conversions, and caching
class _ManufacturerService {

    public allManufacturers: IManufacturer[] = [{id: -1, name:"", modifiedBy: ""}];

    public getManufacturers = (query: IManufacturerQuery): Promise<IManufacturer[]> => {

        const p = axiosAPI.get<IManufacturerAPI[]>('/manufacturers', {params: query})
            .then((resp) => {
                var mans = resp.data.map(this.mapManufacturerFromServer);

                const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                mans.sort((a, b) => collator.compare(a.name, b.name));

                this.allManufacturers.push(...mans);
                return mans;
            });
            
        p.catch((err) => {
            console.error('Error getting manufacturers: ', err);
        });

        return p;
    }

    public createManufacturer = (man: IManufacturer): Promise<IManufacturerCreateResponse> => {

        const p = axiosAPI.post<IManufacturerCreateResponse>('/manufacturers', this.mapManufacturerToServer(man))
            .then((resp) => {
                return resp.data;
            });
            
        p.catch((err) => {
            console.error('Error creating manufacturer: ', err);
        });

        return p;
    }

    public updateManufacturer = (id: number, man: IManufacturer): Promise<IManufacturerCreateResponse> => {

        const p = axiosAPI.patch<IManufacturerCreateResponse>(`/manufacturers/${id}`, this.mapManufacturerToServer(man))
            .then((resp) => {
                return resp.data;
            });
            
        p.catch((err) => {
            console.error('Error updating manufacturer: ', err);
        });

        return p;
    }

    public deleteManufacturer = (id: number): Promise<any> => {

        const p = axiosAPI.delete(`/manufacturers/${id}`)
            .then((resp) => {
                return resp.data;
            });
            
        p.catch((err) => {
            console.error('Error deleting manufacturer: ', err);
        });

        return p;
    }

    public mapManufacturerFromServer = (m: IManufacturerAPI): IManufacturer => {
        return {
            ...m,
            createdAt: m.createdAt ? new Date(m.createdAt) : undefined,
            updatedAt: m.updatedAt ? new Date(m.updatedAt) : undefined,
        }
    }

    public mapManufacturerToServer = (m: IManufacturer): IManufacturerAPI => {
        return {
            ...m,
            id: m.id ? m.id : 0,
            createdAt: m.createdAt ? m.createdAt.toISOString() : "",
            updatedAt: m.updatedAt ? m.updatedAt.toISOString() : "",
        }
    }
}

export const ManufacturerService = new _ManufacturerService();
